import { useContext } from 'react';
import { createContext } from 'react';

import { ProductGiftListProps } from '../@types/ProductGiftListProps';

export const ProductGiftListContext = createContext<ProductGiftListProps>({} as ProductGiftListProps);

ProductGiftListContext.displayName = 'ProductGiftList';

const ProductGiftListProvider = (props: ProductGiftListProps) => (
	<ProductGiftListContext.Provider value={props}>{props.children}</ProductGiftListContext.Provider>
);

export const useProductGiftList = () => {
	const context = useContext(ProductGiftListContext);

	return context;
};

export default ProductGiftListProvider;
